// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table thead {
  border-bottom: 2px solid #acb7c9;
}

.table thead th, .table tbody tr td {
  font-size: 13px;
}

.table tbody tr:hover {
  background-color: #d8e8ee !important;
  transition: all 0.5s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/policy-configurator/version-details/version-details.component.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;;AACA;EAAmC,eAAA;AAGnC;;AACA;EACI,oCAAA;EACA,yBAAA;AAEJ","sourcesContent":[".table thead{\r\n    border-bottom: 2px solid #acb7c9;\r\n}\r\n.table thead th,.table tbody tr td{font-size: 13px;}\r\n// .table tbody tr td{\r\n//     padding: 5px 10px;\r\n// }\r\n.table tbody tr:hover{\r\n    background-color: #d8e8ee !important;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
